import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import MessageModal from '@wix/da-ds/pkg/modals/dsPresets/MessageModal';
import {
  CancelButton,
  ConfirmButton,
} from '@wix/da-ds/pkg/modals/dsPresets/MessageModal/buttons';
import { MODAL_FOOTER_BUTTON_SIZE } from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import BuyCoreBrandedButton from '../../../../Button/core/dsPresets/BuyCoreBrandedButton';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import { BiData, BuyCoreButtonBiEvent } from '@wix/da-bi/pkg/events';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import s from './DownloadLimitModal.scss';

interface Props {
  allocation: number;
  onRequestClose: () => void;
}

const DownloadLimitModal: React.FC<Props> = ({
  allocation,
  onRequestClose,
}) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const { hasCoreMembership, coreLevel } = useContext(SessionContext);

  const isNonCoreTier = !hasCoreMembership || coreLevel === 'core_access';
  const illustrationSrc = isNonCoreTier
    ? 'https://st.deviantart.net/eclipse/illustrations/il2.15_core_ball_pixel.png'
    : 'https://st.deviantart.net/eclipse/illustrations/dripping_mark.png';

  return (
    <MessageModal
      isOpen
      className={s['root']}
      onRequestClose={onRequestClose}
      image={<img src={illustrationSrc} width="90" height="88" alt="" />}
      variant={isMobile ? 'vertical' : 'horizontal'}
      title={t('downloadLimit.modal.title')}
      message={
        isNonCoreTier
          ? t('downloadLimit.modal.message.nonCore', { count: allocation })
          : t('downloadLimit.modal.message.core', { count: allocation })
      }
      footerButtons={
        isNonCoreTier
          ? [
              <CancelButton key="cancel" onClick={onRequestClose}>
                {t('popup.cancel')}
              </CancelButton>,
              <BuyCoreBrandedButton
                key="upgrade"
                size={MODAL_FOOTER_BUTTON_SIZE}
                biData={BiData<BuyCoreButtonBiEvent>({
                  evid: 375,
                  referral_info: ReferralType.ANON_DOWNLOAD,
                })}
              >
                {t('downloadLimit.modal.cta.upgrade')}
              </BuyCoreBrandedButton>,
            ]
          : [
              <CancelButton key="cancel" onClick={onRequestClose}>
                {t('popup.cancel')}
              </CancelButton>,
              <ConfirmButton key="ok" onClick={onRequestClose}>
                {t('common.ok')}
              </ConfirmButton>,
            ]
      }
    />
  );
};
DownloadLimitModal.displayName = 'DownloadLimitModal';

export default DownloadLimitModal;
